import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                      */
const UserInfoOverview = ({ className, user, ...rest }) => {
  if (!user.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("user-info-overview", className) }, user.map(({ label, value }) => /* @__PURE__ */ React.createElement(React.Fragment, { key: label }, /* @__PURE__ */ React.createElement(Text, { className: "user-info-overview__label", variant: "body-head" }, label), /* @__PURE__ */ React.createElement(Text, { className: "user-info-overview__value" }, value))));
};
export {
  UserInfoOverview as default
};
//# sourceMappingURL=UserInfoOverview.js.map
